// src/components/CalculationCheck.js
import React, { useState } from 'react';
import { CheckCircle, AlertTriangle, ChevronUp, ChevronDown, Activity } from 'react-feather';

function CalculationCheck({ isValid, status, details, missingData, potentialMissingPayments, calculated_TotalTax, calculated_Payments }) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Determine styling based on state
  let bgColor = '#10b981'; // Green (Success)
  let icon = <CheckCircle size={20} />;
  
  if (!isValid) {
    bgColor = '#f59e0b'; // Amber/Yellow (Math Mismatch)
    icon = <Activity size={20} />;
  }
  if (missingData && missingData.length > 0) {
    // --- CHANGED: Blue to Orange ---
    bgColor = '#ea580c'; // Dark Orange (Review Needed/Missing Data)
  }

  const formatMoney = (val) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(val || 0);

  return (
    <div className="calculation-check-container" style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    }}>
      
      {/* Expanded Details Panel */}
      {isExpanded && (
        <div style={{
          backgroundColor: 'white',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          padding: '15px',
          marginBottom: '10px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
          width: '300px',
          fontSize: '0.9rem'
        }}>
          <h4 style={{ margin: '0 0 10px 0', borderBottom: '1px solid #eee', paddingBottom: '5px' }}>Audit Breakdown</h4>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span>Income Calculation:</span>
            <span>{details.income ? '✅' : '❌'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span>Deductions & AGI:</span>
            <span>{details.agi ? '✅' : '❌'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span>Tax Liability ({formatMoney(calculated_TotalTax)}):</span>
            <span>{details.tax ? '✅' : '❌'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span>Payments ({formatMoney(calculated_Payments)}):</span>
            <span>{details.payments ? '✅' : '❌'}</span>
          </div>

          {potentialMissingPayments && (
             <div style={{ marginTop: '10px', padding: '8px', backgroundColor: '#fff7ed', borderRadius: '4px', border: '1px solid #fed7aa', fontSize: '0.8rem', color: '#9a3412' }}>
               <AlertTriangle size={12} style={{ marginRight: '4px' }}/>
               <strong>High Tax / Low Payments:</strong> You owe tax but haven't entered any Estimated Payments. Did you pay quarterly taxes?
             </div>
          )}

          {missingData.length > 0 && (
            <div style={{ marginTop: '10px', color: '#ea580c', fontSize: '0.85rem' }}>
              <strong>Missing Info:</strong> {missingData.join(', ')}
            </div>
          )}
        </div>
      )}

      {/* Main Status Bar */}
      <div 
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          backgroundColor: bgColor,
          color: 'white',
          padding: '10px 15px',
          borderRadius: '30px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          transition: 'all 0.2s'
        }}
      >
        {icon}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>{status}</span>
          <span style={{ fontSize: '0.75rem', opacity: 0.9 }}>
            {isValid ? 'All figures reconciled' : 'Click for details'}
          </span>
        </div>
        {isExpanded ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
      </div>
    </div>
  );
}

export default CalculationCheck;